import { render } from "./RecomendacionesIA.vue?vue&type=template&id=44c0def6"
import script from "./RecomendacionesIA.vue?vue&type=script&lang=js"
export * from "./RecomendacionesIA.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__